<template>
  <main-box-sc>
    <div class="picker">
      <!-- 滚动内容 -->
      <div class="picker-column"
           @touchstart="onTouchStart"
           @touchmove="onTouchMove"
           @transitionend="onTransitionEnd"
           @touchend="onTouchEnd"
           @touchcancel="onTouchEnd"
      >
        <ul :style="wrapperStyle" class="wrapper-container">
          <li v-for="(item, index) in initOptions.options" :key="item" class="column-item" :style="liStyle(index)" >{{ item }}</li>
        </ul>
      </div>
      <!-- 遮照层 -->
      <div class="mask" :style="maskStyle"></div>
      <div class="cover-border"></div>
    </div>
  </main-box-sc>
</template>

<script>
import {MainBoxSc} from './pickerSc';
import { ref, onMounted, computed, nextTick, watch } from 'vue';
import usePicker from './index'

export default {
  name: 'Picker',
  components:{
    MainBoxSc
  },
  props: {
    //当前选择值
    modelValue: Number,
    //数据对象
    initOptions: {
      type: Object,
      default: () => {}
    },
    //重置当前选择索引
    resetIndex: {
      type: Boolean,
      default: false
    }
  },
  setup(props,{ emit }) {
    let currentIndex = ref(0); //当前选中索引
    //日期更新事件
    const updateValue = (val) => {
      emit('update:modelValue', val);
    };
    //派发事件
    const emitChangeEvent = (index) => {
      updateValue(props.initOptions.realOptions[index].value);
      emit('setOption', props.initOptions.realOptions[index].value, props.initOptions.flag);
    };
    //引入./index.js
    const {
      setIndex,
      liStyle,
      frameStyle,
      maskStyle,
      wrapperStyle,
      onTouchStart,
      onTouchMove,
      onTransitionEnd,
      onTouchEnd,
    } = usePicker(props, currentIndex, emitChangeEvent);

    onMounted(() => {
      //初始化设置默认选择日期
      let _val = props.initOptions.realOptions.findIndex(s => s.value === props.modelValue);
      setIndex(_val, true, props.initOptions.realOptions);
    });

    watch(() => props.resetIndex, (newValue, oldValue) => {
      if(newValue){
        let len = props.initOptions.realOptions.length;
        //下级列表长度判断调整
        if(len - 1 < currentIndex.value){
          setIndex(len - 1, true)
          return;
        }
        //下级列表当前选项可用性判断调整
        if(props.initOptions.realOptions[currentIndex.value]['disabled'] !== false){
          setIndex(props.initOptions.realOptions.findIndex(s => !s.disabled), true);
        }
        emit('updateResetIndex');
      }
    });

    return {
      liStyle,
      frameStyle,
      maskStyle,
      wrapperStyle,
      onTouchStart,
      onTouchMove,
      onTransitionEnd,
      onTouchEnd,
    };
  }
};
</script>